// // // // DEV ✅
// // // // apiSlice.js
// // // import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// // // import { BASE_URL } from "../constants";

// // // const baseQuery = fetchBaseQuery({ baseUrl: BASE_URL, credentials: "include" });

// // // export const apiSlice = createApi({
// // //   baseQuery,
// // //   tagTypes: ["Category"],
// // //   endpoints: (builder) => ({}),
// // // });

// // //PROD ✅
// // // apiSlice.js
// // import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// // import { BASE_URL } from "../constants";

// // const baseQuery = fetchBaseQuery({
// //   baseUrl: BASE_URL,
// //   credentials: "include", //  Good! Includes cookies
// // });

// // export const apiSlice = createApi({
// //   baseQuery,
// //   tagTypes: ["Category"],
// //   endpoints: (builder) => ({}),
// // });

// // // DYNAMIC ✅
// // // apiSlice.js
// // // import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// // // import { BASE_URL } from "../constants";

// // // const isProduction = process.env.NODE_ENV === "production";

// // // const baseQuery = fetchBaseQuery({
// // //   baseUrl: BASE_URL,
// // //   credentials: isProduction ? "include" : "same-origin",
// // //   // ✅ "include" needed for cross-site HTTPS cookies
// // //   // ✅ "same-origin" is the default behavior in dev (no change!)
// // // });

// // // export const apiSlice = createApi({
// // //   baseQuery,
// // //   tagTypes: ["Category"],
// // //   endpoints: (builder) => ({}),
// // // });

// //PROD ✅
// // apiSlice.js
// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { BASE_URL } from "../constants";

// const baseQuery = fetchBaseQuery({
//   baseUrl: BASE_URL,
//   credentials: "include", //  Good! Includes cookies
// });

// export const apiSlice = createApi({
//   baseQuery,
//   tagTypes: ["Category"],
//   endpoints: (builder) => ({}),
// });

// src/slices/apiSlice.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants";

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  credentials: "include", // First try cookies
  prepareHeaders: (headers, { getState }) => {
    const token = getState().frontendAuth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ["Category"],
  endpoints: (builder) => ({}),
});
